import Bank from "../model/Bank";
import { addPresentation } from "./presentation";

export default addPresentation(Bank, {
  sort: (a, b) =>
    a?.country?.name?.localeCompare(b?.country?.name) === 0
      ? a?.name?.localeCompare(b?.name)
      : a?.country?.name?.localeCompare(b?.country?.name),
  canAdd: true,
  canEdit: true,
  canRemove: false,
  columns: [
    { title: "Country", width: "30%", align: "left", content: { name: "country.name" } },
    { title: "Name", width: "70%", align: "left", content: { name: "name" } },
  ],
});
